import secureLocalStorage from 'react-secure-storage';
import { persistRoleSession, SESSION_UPDATED_EVENT } from './authSession';

const USER_SESSION_KEY = 'userSession';
const USER_TOKEN_KEY = 'userToken';
const USER_REFRESH_TOKEN_KEY = 'userRefreshToken';

const parseStoredSession = (value) => {
    if (!value) {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getUserSession = () => {
    return parseStoredSession(localStorage.getItem(USER_SESSION_KEY));
};

export const persistUserSession = (sessionUpdates) => {
    const currentSession = getUserSession() || {};
    const nextSession = {
        ...currentSession,
        ...sessionUpdates
    };

    localStorage.setItem(USER_SESSION_KEY, JSON.stringify(nextSession));

    if (nextSession.token) {
        persistRoleSession({
            role: 'user',
            token: nextSession.token,
            refreshToken: nextSession.refreshToken
        });
        secureLocalStorage.setItem('tk', nextSession.token);
        localStorage.setItem(USER_TOKEN_KEY, nextSession.token);
        localStorage.setItem('user', 'true');
        localStorage.setItem('userToken', nextSession.token);
    }

    if (nextSession.refreshToken) {
        secureLocalStorage.setItem('refreshToken', nextSession.refreshToken);
        localStorage.setItem('refreshToken', nextSession.refreshToken);
        localStorage.setItem(USER_REFRESH_TOKEN_KEY, nextSession.refreshToken);
    }

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(SESSION_UPDATED_EVENT));
    }

    return nextSession;
};

export const getUserAccessToken = () => {
    return secureLocalStorage.getItem('tk') || localStorage.getItem(USER_TOKEN_KEY) || getUserSession()?.token || null;
};

export const getUserRefreshToken = () => {
    return secureLocalStorage.getItem('refreshToken') || localStorage.getItem(USER_REFRESH_TOKEN_KEY) || localStorage.getItem('refreshToken') || getUserSession()?.refreshToken || null;
};

export const clearUserSession = () => {
    secureLocalStorage.removeItem('tk');
    secureLocalStorage.removeItem('refreshToken');
    localStorage.removeItem(USER_TOKEN_KEY);
    localStorage.removeItem(USER_REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_SESSION_KEY);
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userToken');

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(SESSION_UPDATED_EVENT));
    }
};